/**
 * ============================================================================
 * TRANSIENT: Appointment Config Page (appointment-config-page)
 * Type: poc
 * Amplitude key: none
 * End date: 2026-12-31
 * PR: #TODO_AFTER_PR_CREATION_appointment-config-page
 * ============================================================================
 */

import { Box, Button, Chip, Typography, paletteColors } from '@evaneos/b2b-ui';

export const AppointmentWipContentPartial = (): JSX.Element => (
    <Box
        data-spec-id="agenda-rdv-wip-card"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            gap: 2,
            p: 4,
        }}
    >
        <Chip
            label="Prochainement"
            sx={{
                bgcolor: paletteColors.blue[100],
                color: paletteColors.blue[800],
                fontWeight: 700,
            }}
        />
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {/* @todo translate: agenda.rdv.wip_title */}
            Tous vos rendez-vous, en un coup d&apos;œil
        </Typography>
        <Button
            data-spec-id="agenda-rdv-notify-button"
            variant="contained"
            onClick={() => {
                // @todo amplitude: track rdv_wip_notify_clicked once event is defined in Amplitude schema
            }}
        >
            {/* @todo translate: agenda.rdv.notify_button */}
            Me prévenir dès la sortie
        </Button>
    </Box>
);
